/**
 * Reconnect ladder shared by the relay socket and the SIP transport: 1, 2, 4, 8 s then capped
 * at 15 s, ±30 % jitter, unlimited attempts.
 */
export const BACKOFF_LADDER_S = [1, 2, 4, 8] as const;
export const BACKOFF_CAP_S = 15;
export const BACKOFF_JITTER = 0.3;

/** base delay (ms) for the n-th consecutive failure (0-based) before jitter */
export function backoffBaseMs(attempt: number): number {
  const i = Math.max(0, Math.floor(attempt));
  return (BACKOFF_LADDER_S[i] ?? BACKOFF_CAP_S) * 1000;
}

/** `base * (1 ± 0.3)` with `random()` in [0, 1) */
export function jitterMs(baseMs: number, random: () => number = Math.random): number {
  const r = Math.min(1, Math.max(0, random()));
  return Math.round(baseMs * (1 + (r * 2 - 1) * BACKOFF_JITTER));
}

export function backoffDelayMs(attempt: number, random: () => number = Math.random): number {
  return jitterMs(backoffBaseMs(attempt), random);
}
